import type { FormDataType } from 'integrations/types';

import type { AWSSecurityLakeGenericInputCreateRequest, AWSSecurityLakeInputCreateRequest } from '../types';
import { AWS_AUTH_TYPES } from '../../common/aws/AWSAuthenticationTypes';

export const toAWSSecurityLakeInputCreateRequest = ({
  awsSecurityLakeName,
  awsAuthenticationType,
  awsSecurityLakeStoreFullMessage,
  awsSecurityLakeThrottleEnabled,
  pollingInterval,
  awsAccessKey,
  awsSecretKey,
  securityLakeSqsQueueName,
  securityLakeRegion,
  key,
  secret,
  assumeRoleArn,
}: FormDataType): AWSSecurityLakeInputCreateRequest => ({
  name: awsSecurityLakeName.value,
  ...(awsAuthenticationType?.value === AWS_AUTH_TYPES.keysecret
    ? {
      aws_access_key: awsAccessKey?.value,
      aws_secret_key: awsSecretKey?.value,
    }
    : {
      aws_access_key: key,
      aws_secret_key: secret,
    }),
  polling_interval: pollingInterval.value,
  polling_time_unit: 'MINUTES',
  store_full_message: !!awsSecurityLakeStoreFullMessage?.value,
  enable_throttling: !!awsSecurityLakeThrottleEnabled?.value,
  security_lake_queue_name: securityLakeSqsQueueName.value,
  aws_region: securityLakeRegion.value,
  assume_role_arn: assumeRoleArn?.value,
});

export const toGenericInputCreateRequest = ({
  awsSecurityLakeName,
  awsAuthenticationType,
  awsSecurityLakeStoreFullMessage,
  awsSecurityLakeThrottleEnabled,
  awsAccessKey,
  awsSecretKey,
  pollingInterval,
  securityLakeSqsQueueName,
  securityLakeRegion,
  key,
  secret,
  assumeRoleArn,
}: FormDataType): AWSSecurityLakeGenericInputCreateRequest => ({
  type: 'org.graylog.enterprise.integrations.awssecuritylake.SecurityLakeInput',
  title: awsSecurityLakeName.value,
  global: false,
  configuration: {
    ...(awsAuthenticationType?.value === AWS_AUTH_TYPES.keysecret
      ? {
        aws_access_key: awsAccessKey?.value,
        aws_secret_key: awsSecretKey?.value,
      }
      : {
        aws_access_key: key,
        aws_secret_key: secret,
      }),
    polling_interval: pollingInterval.value,
    polling_time_unit: 'MINUTES',
    store_full_message: !!awsSecurityLakeStoreFullMessage?.value,
    throttling_allowed: !!awsSecurityLakeThrottleEnabled?.value,
    security_lake_queue_name: securityLakeSqsQueueName.value,
    aws_region: securityLakeRegion.value,
    assume_role_arn: assumeRoleArn?.value,
  },
});
